{
  "nav": {
    "home": "首页",
    "project": "项目",
    "science": "科学",
    "team": "团队",
    "updates": "动态",
    "getInvolved": "加入"
  },
  "footer": {
    "tagline": "AquaWorks 网站位于不列颠哥伦比亚大学温哥华校园",
    "description": "AquaWorks 是由不列颠哥伦比亚大学学生开发的学生主导工程项目，正在建造雷达辅助水质监测机器人。",
    "quickLinks": "探索",
    "copyright": "© {{year}} AquaWorks."
  },
  "common": {
    "placeholder": "内容即将上线。",
    "backToHome": "返回首页",
    "source": "来源",
    "planned": "计划中",
    "notCertification": "学生原型。非专业监测或用水安全认证。"
  },
  "memberCard": {
    "program": "学院",
    "focus": "方向"
  },
  "languageSwitcher": {
    "chinese": "中文",
    "english": "English",
    "french": "Français",
    "ariaLabel": "切换语言"
  },
  "sourceDocuments": {
    "spf": "AMS 可持续项目基金申请",
    "timeline": "AquaWorks 第一阶段时间线",
    "ismp": "温哥华校园综合雨水管理计划",
    "seeds": "SEEDS 雨水花园与绿色雨水基础设施报告"
  }
}
